import React from "react";
import { RiEditBoxFill } from "react-icons/ri";
import BaseSection from "../components/BaseSection";
import TextInput from "../components/Input/TextInput";
import { Grid } from "@material-ui/core";
import TextAreaInput from "../components/Input/TextAreaInput";

export const INITIAL_TRAIL_SECTION_INPUTS = {
  TRAIL_NAME: "trail_name",
  TRAIL_DESCRIPTION: "trail_description",
  TRAIL_COURSE_IDS: "trail_course_ids",
};

export default function InitialTrailSection({
  inputs = {},
  errors = {},
  onChangeInput = () => null,
}) {
  return (
    <BaseSection title="Criação de trilha (Opcional)" Icon={<RiEditBoxFill />}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextInput
            label="Título da Trilha"
            type="text"
            placeholder="Título da Trilha a ser cadastrada"
            value={inputs[INITIAL_TRAIL_SECTION_INPUTS.TRAIL_NAME]}
            errorMessage={errors[INITIAL_TRAIL_SECTION_INPUTS.TRAIL_NAME]}
            onChange={(e) =>
              onChangeInput(
                INITIAL_TRAIL_SECTION_INPUTS.TRAIL_NAME,
                e.target.value
              )
            }
          />
        </Grid>
        <Grid item xs={12}>
          <TextAreaInput
            label="Descrição da Trilha"
            placeholder="Descrição da Trilha a ser cadastrada"
            value={inputs[INITIAL_TRAIL_SECTION_INPUTS.TRAIL_DESCRIPTION]}
            errorMessage={
              errors[INITIAL_TRAIL_SECTION_INPUTS.TRAIL_DESCRIPTION]
            }
            onChange={(e) =>
              onChangeInput(
                INITIAL_TRAIL_SECTION_INPUTS.TRAIL_DESCRIPTION,
                e.target.value
              )
            }
          />
        </Grid>
        <Grid item xs={12}>
          <TextInput
            label="Cursos"
            type="text"
            placeholder="Cursos da Trilha a ser cadastrada"
            helperText={
              <a
                href="/admin/cursos/conteudo"
                target="_blank"
                style={{ color: "#0F7DE2", textDecoration: 'underline' }}
              >
                Link para consultado dos IDs
              </a>
            }
            value={inputs[INITIAL_TRAIL_SECTION_INPUTS.TRAIL_COURSE_IDS]}
            errorMessage={errors[INITIAL_TRAIL_SECTION_INPUTS.TRAIL_COURSE_IDS]}
            onChange={(e) =>
              onChangeInput(
                INITIAL_TRAIL_SECTION_INPUTS.TRAIL_COURSE_IDS,
                e.target.value
              )
            }
          />
        </Grid>
      </Grid>
    </BaseSection>
  );
}
